<!-- 拍卖组件 -->
<template>
  <div :class="{ actionOuter: auctionDetail ? false : true }">
    <div class="pmcoment" v-if="auctionDetail">
      <div class="pmleft">
        <div class="pmimg" v-show="bidding === -1 ? false : true">
          <!-- 即将开始 -->
          <div class="pmstart" v-show="bidding === 0 ? true : false">
            <img src="../../assets/starthot.gif" alt="" />
            <span>拍卖信息</span>
          </div>

          <!-- 进行中 -->
          <div class="pmstart" v-show="bidding === 1 ? true : false">
            <img src="../../assets/hot.gif" alt="" />
            <span>拍卖信息</span>
          </div>
        </div>
        <div class="pmzti">
          <h3
            :class="{
              noStartit: bidding === 0,
              endTit: bidding === -1,
              isBobao: bidding === 1 && isBroad,
              noStartit: bidding === 1 && !isBroad,
            }"
          >
            {{ auctionDetail.auctionTitle }}
          </h3>
          <div class="pmmishu">
            <span>{{ auctionDetail.dataLocationShow }}</span>
            <span
              >{{ auctionDetail.belongingYear
              }}{{ auctionDetail.dataTypeShow }}</span
            >
            <i>出售方:</i
            ><b class="gyqilabel">{{ auctionDetail.supplierCompanyName }}</b>
            <b class="gyangqi" v-show="auctionDetail.companyType === 1">{{
              auctionDetail.companyTypeShow
            }}</b>
            <i style="margin-left: 4px">| 碳信分:</i>
            <CarbonCredits
              :cordeNumber="auctionDetail.carbonCredits"
              :isLogin="islogin"
              :bidding="bidding"
              isPages="index"
            ></CarbonCredits>
            <!-- 观看次数 -->
            <div class="cview">
              <img src="../../assets/eyes.png" alt="" />
              <b>{{ auctionDetail.participantsNumber }}</b>
              <span>次围观</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pmright">
        <div class="pmtime">
          <!-- 结束｜未开始 -->
          <div class="ended" v-if="bidding !== 1">
            <!-- 未开始 -->
            <div v-if="bidding === 0">
              <div v-show="isOneHour" class="start">
                <b>距开始：</b>
                <span>{{ updataTimer[0] }}</span>
                <b>:</b>
                <span>{{ updataTimer[1] }}</span>
                <b>:</b>
                <span>{{ updataTimer[2] }}</span>
              </div>
              <div v-show="!isOneHour">
                {{ updataTimer[0] }}
              </div>
            </div>
            <!-- 已结束 -->
            <div v-if="bidding === -1">
              {{ updataTimer[0] }}
            </div>
          </div>
          <!-- 进行中 -->
          <div class="startOuter" v-else>
            <div class="start">
              <b>距截止：</b>
              <span>{{ updataTimer[0] }}</span>
              <b>:</b>
              <span>{{ updataTimer[1] }}</span>
              <b>:</b>
              <span>{{ updataTimer[2] }}</span>
            </div>
            <!-- 已报价轮播 -->
            <BroadcastIndex
              class="broadcastIndex"
              v-show="isBroad"
              :message-list="broadData"
            ></BroadcastIndex>
          </div>
        </div>

        <div class="pmtxt" :class="{ pmtxting: bidding === 1 }">
          <div class="trow">
            <span>数量：</span
            ><b>{{ addThousandsSeparator(auctionDetail.totalQuantity) }}</b
            ><span>吨</span>
          </div>
          <div class="trow">
            <span>起拍价：</span><b>¥{{ auctionDetail.startPrice }}</b>
          </div>
        </div>
        <div
          class="pmgo"
          :class="{ pmgo1: bidding !== 1, pmgo2: bidding === 1 }"
          @click="gotoAction"
        >
          <span v-if="bidding !== 1">查看详情</span>
          <div class="pmimgo" v-else>
            <img src="../../assets/paimai.png" alt="" />
            <span>去出价</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBidList } from "@/api/actions.js";
export default {
  name: "action",
  components: {
    CarbonCredits: () => import("@/components/actions/carbonCredits.vue"),
    BroadcastIndex: () => import("@/components/actions/broadcastIndex.vue"),
  },
  data() {
    return {
      broadData: [], // 播报数据
      updateTimer: null, // 播报定时器
      isBroad: false, // 是否有播报数据
      islogin: true,
    };
  },
  computed: {
    isOneHour() {
      return this.$store.state.actions.isOneHour;
    },
    bidding() {
      return this.$store.state.actions.bidding;
    },
    updataTimer() {
      return this.$store.state.actions.updataTimer;
    },
    auctionDetail() {
      return this.$store.state.actions.auctionDetail;
    },
  },
  watch: {
    bidding(newVal) {
      // console.error(newVal, "监测====");
      if (newVal === 1) {
        this.startAutoUpdate();
      } else {
        this.stopAutoUpdate();
      }
    },
  },
  async created() {
    // this.$store.dispatch("actions/fetchGlobalMessage", true);
    // 检查是否登录
    this.islogin = await this.$store.dispatch("actions/checkLogin");
    console.log(this.islogin, "是否登录");
    await this.$store.dispatch("actions/fetchAuctionDetail");
    await this.getBidList();
    if (this.bidding === 1) {
      // 启动定时更新
      this.startAutoUpdate();
    }
  },
  beforeDestroy() {
    // 清除定时器
    this.stopAutoUpdate();
  },
  methods: {
    // 开始自动更新
    startAutoUpdate() {
      this.updateTimer = setInterval(() => {
        this.getBidList();
      }, 60000); // 每1分钟请求一次
    },
    // 停止自动更新
    stopAutoUpdate() {
      if (this.updateTimer) {
        clearInterval(this.updateTimer);
        this.updateTimer = null;
      }
    },
    // 报价列表
    async getBidList() {
      try {
        const response = await getBidList({
          auctionInfoId: this.auctionDetail.id,
        });
        if (response.code === 0) {
          this.broadData = response.data;
          // console.log("报价列表:", response.data);
          if (this.broadData.length > 0) {
            this.isBroad = true;
          } else {
            this.isBroad = false;
          }
        } else {
          console.error("获取报价列表失败:", response.message);
        }
      } catch (error) {
        console.error("获取报价列表异常:", error);
      }
    },
    addThousandsSeparator(number) {
      if (number === null || number === undefined) return "";
      const str = typeof number === "string" ? number : number.toString();
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    gotoAction() {
      this.$router.push({ path: "/auctionDetail" });
    },
  },
};
</script>

<style scoped lang="scss">
.actionOuter {
  width: 100%;
  height: 64px;
}
.pmcoment {
  height: 88px;
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .pmleft {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .pmimg {
    width: 141px;
    height: 88px;
    .pmstart {
      width: 141px;
      height: 88px;
      background: url("../../assets/pmbg.png") no-repeat center center;
      background-size: contain;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 127px;
      }
      span {
        font-weight: 400;
        font-size: 13px;
        color: #63300e;
        line-height: 22px;
        margin-top: -7px;
      }
    }
    // img {
    //   width: 141px;
    // }
  }
  .pmzti {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: 24px;
    // position: relative;
    h3 {
      font-size: 18px;
      color: #03102b;
      line-height: 26px;
      font-weight: 600;
      text-align: left;
    }
    h3.noStartit {
      width: 570px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    h3.endTit {
      width: 786px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    h3.isBobao {
      width: 433px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .pmmishu {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 9px;
    white-space: nowrap;
    span {
      font-size: 12px;
      color: #4aab3d;
      padding: 4px 6px;
      border-radius: 4px;
      background-color: rgba(74, 171, 61, 0.1);
      margin-right: 8px;
    }
    i {
      color: #83879b;
      font-size: 12px;
      margin-right: 4px;
      margin-left: 8px;
    }
    b {
      font-size: 12px;
      margin-right: 4px;
    }
    b.gyqilabel {
      font-weight: 500;
      font-size: 12px;
      color: #03102b;
      line-height: 20px;
    }
    b.gyangqi {
      font-weight: 400;
      font-size: 12px;
      color: #63300e;
      line-height: 20px;
      border-radius: 4px;
      background: linear-gradient(91deg, #fef7cb 0%, #fae3c6 100%);
      padding: 2px 6px;
    }
    .cview {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-left: 16px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 2px;
      }
      b {
        font-weight: 400;
        font-size: 14px;
        color: #41464f;
        margin-right: 0px;
      }
      span {
        font-weight: 400;
        font-size: 12px;
        color: #83879b;
        background: none;
        padding: 0px;
      }
    }
  }
  .pmright {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-right: 24px;
    margin-left: -12px;
    .pmtime {
      font-size: 12px;
      .startOuter {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .broadcastIndex {
          margin-left: 32px;
        }
      }

      .start {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        span {
          font-size: 14px;
          color: #ffffff;
          background-color: #4aab3d;
          padding: 4px;
          border-radius: 4px;
        }
        b {
          margin-right: 4px;
          margin-left: 4px;
          white-space: nowrap;
        }
      }
    }
    .pmtxt {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      margin-left: 48px;
      .trow {
        line-height: 22px;
        white-space: nowrap;
        span {
          color: #83879b;
          font-size: 12px;
        }
        b {
          color: #03102b;
          font-size: 14px;
          font-weight: 600;
          margin-right: 2px;
          font-family: sans-serif;
        }
      }
    }
    .pmtxting {
      margin-left: 32px;
    }
    .pmgo {
      font-size: 14px;
      color: #ffffff;
      background: #4aab3d;
      border-radius: 4px;
      width: 106px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 48px;
      .pmimgo {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }
    }
    .pmgo1 {
      width: 106px;
    }
    .pmgo2 {
      margin-left: 32px;
    }
  }
}
</style>
